import { createFileRoute } from "@tanstack/react-router";
import { QueueBoard } from "../board/QueueBoard";

export const Route = createFileRoute("/_authed/")({ component: QueueBoard });
